import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { EyeDotted } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import limits from '@ads/front-core/constants/limits'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'

export const UNIVERSAL_VCPM: IProductDefinition = {
  productTypeId: 'UNIVERSAL_VCPM',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/universal-vcpm/',
  title: 'campaign:displayVCPM.displayVCPM',
  budget: {
    model: 'VCPM',
    type: 'TOTAL',
    variant: 'ANY',
    validation: {
      globalLimit: {
        min: limits.MINIMUM_BUDGET,
      },
      dailyLimit: {
        min: limits.MINIMUM_DAILY_BUDGET,
      },
      rate: {
        min: 0.3,
      },
    },
  },
  campaignHowToWorks: 'campaign:displayVCPM.howDisplayVCPMWorks',
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'currency',
  },
  capping: true,
  allowedCreationTypes: ['BANNER', 'HTML', 'CODE', 'RICH_MEDIA'],
  creationsDescription: {
    description: 'campaign:displayCPC.addMoreCreationsDescription',
  },
  targeting: {
    countries: true,
    demography: true,
    devices: true,
    locations: true,
    segmentsTab: ['segments', 'retargetingSegments'],
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.DISPLAY_CPM,
    productDescription: {
      title: lng('wizard:numberOfViews'),
      description: lng('wizard:displayVCPMDescription'),
      Icon: EyeDotted,
    },
    parameters: [
      {
        label: lng('campaign:format'),
        value: lng('campaign:banner'),
      },
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.vcpm'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('wizard:buildingAwarenessReach'),
      },
    ],
  },
}
